/** Returns usable map dimensions, or null values while Leaflet is still measuring the map. */
export const getMapSize = (map) => {
  const size = map?.getSize?.();

  return {
    width: Number.isFinite(size?.x) && size.x > 0 ? size.x : null,
    height: Number.isFinite(size?.y) && size.y > 0 ? size.y : null,
  };
};
